export const MAIL_REFUSAL_FLAG_DEFAULT_VALUE = false as const;
